// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../../BaseIcon";
import type { BaseIconProps } from "../../types";

const solidContent = `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_more--line"><path id="Union" d="M35.4167 20.7326C35.7721 20.8955 36 21.2507 36 21.6417V24.3583C36 24.7493 35.7721 25.1045 35.4167 25.2674L12 36V32L31.6348 23L12 14V10L35.4167 20.7326Z" style="fill: currentColor"/></g></svg>`;
const lineContent = `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_more--line"><path id="Union" d="M35.4167 20.7326C35.7721 20.8955 36 21.2507 36 21.6417V24.3583C36 24.7493 35.7721 25.1045 35.4167 25.2674L12 36V32L31.6348 23L12 14V10L35.4167 20.7326Z" style="fill: currentColor"/></g></svg>`;

export const More: React.FC<BaseIconProps> = (props) => (
  <BaseIcon {...props} solidContent={solidContent} lineContent={lineContent} />
);
